import * as api from '../../services/api';

export default {

  data() {
    return {
      toolList: [],
      currentSort: 'RemainingDay',
      currentSortDir: 'asc',
      pageSize: 6,
      currentPage: 1,
    };
  },
  mounted() {
    api.getToolUpcomingCalibrations().then((res) => {
      this.toolList = res.body.map(item => {
        return {
          ...item,
          NextCalibrationDateText: moment(item.NextCalibrationDate).format('DD-MM-YYYY')
        };
      });
    });
  },
  methods: {
    redraw() {},
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage() {
      if (this.currentPage * this.pageSize < this.toolList.length) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  computed: {
    sortedToolList() {
      return this.toolList.sort((a, b) => {
        let modifier = 1;
        // Siralama ham alanlar uzerinden yapilir: tarih kolonu ekranda bicimlenmis
        // metni gosterse de sirasi DD-MM-YYYY metnine gore degil, gercek tarihe gore
        // cikmali - aksi halde liste gune gore siralanirdi.
        const aValue = this.currentSort === 'NextCalibrationDate'
          ? new Date(a.NextCalibrationDate).getTime()
          : a[this.currentSort];
        const bValue = this.currentSort === 'NextCalibrationDate'
          ? new Date(b.NextCalibrationDate).getTime()
          : b[this.currentSort];

        if (isNaN(aValue) || isNaN(bValue)) {
          // ToolName bos gelebilir (tipi, alt tipi, markasi ve modeli olmayan kayit):
          // localeCompare null uzerinde patlardi.
          const compare = (aValue || '').localeCompare(bValue || '');
          if (this.currentSortDir === 'asc') modifier = -1;
          if (compare > 0) return -1 * modifier;
          if (compare < 0) return 1 * modifier;
        } else {
          if (this.currentSortDir === 'asc') modifier = -1;
          if (aValue > bValue) return -1 * modifier;
          if (aValue < bValue) return 1 * modifier;
        }
        return 0;
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = this.currentPage * this.pageSize;
        if (index >= start && index < end) return true;
      });
    },
    isLastPage() {
      return this.currentPage * this.pageSize >= this.toolList.length;
    },
    isFirstPage() {
      return this.currentPage == 1;
    },
  },
};
